import { render } from "./OrderHistView.vue?vue&type=template&id=c4b3708a&scoped=true"
import script from "./OrderHistView.vue?vue&type=script&lang=js"
export * from "./OrderHistView.vue?vue&type=script&lang=js"

import "./OrderHistView.vue?vue&type=style&index=0&id=c4b3708a&scoped=true&lang=css"
import "./OrderHistView.vue?vue&type=style&index=1&id=c4b3708a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b3708a"]])

export default __exports__